/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrderRetrievePathId, OrderRetrieveStatus200 } from "../types/OrderRetrieve.ts";

function getOrderRetrieveUrl(id: OrderRetrievePathId) {
	const res = { method: "GET", url: `/api/order/${id}/` as const };

	return res;
}

/**
 * @description Миксин формирования сложного запроса для
 * объекта/списка объектов заказа через сайт.
 * {@link /api/order/:id/}
 */
export async function orderRetrieve(id: OrderRetrievePathId, config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrderRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrderRetrieveUrl(id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
